import React from 'react';
import styles from './FeaturesSection.module.css';
import FeaturesGrid from './FeaturesGrid';
import { FEATURES_DATA } from '../../../../constants/landing';

/**
 * @component FeaturesSection
 * @description 서비스 주요 기능 섹션
 */
function FeaturesSection() {
  const handleCardClick = (featureId) => {
    console.log('Feature clicked:', featureId);
  };

  return (
    <section className={styles.featuresSection}>
      {/* Figma 스포트라이트 조명 효과 */}
      <div className={styles.spotlight} aria-hidden="true" />
      <div className={styles.container}>
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>
            왜 <span className={styles.castarHighlight}>Castar</span> 인가요?
          </h2>
          <p className={styles.sectionSubtitle}>{FEATURES_DATA.header.subtitle}</p>
        </div>
        <FeaturesGrid
          features={FEATURES_DATA.features}
          onCardClick={handleCardClick}
        />
      </div>
    </section>
  );
}

export default FeaturesSection;
